import { defineMessages } from 'react-intl'

const scope = `procurify.expense.RequestablePrimaryCategorySelect`

export default defineMessages({
  placeholderText: {
    id: `${scope}.placeholderText`,
    defaultMessage: 'Select {singularPrimaryOrgCategoryLabel}',
  },
})
